import Head from 'next/head'
import { GLOBAL_CONSTANT } from '../libs/utils/constants'
import { BREAKPOINTS } from '../libs/utils/constants/layout'
import styled from 'styled-components'
import Error404 from '@App/libs/components/error/Error'
import { GetStaticPropsResult, NextPage } from 'next'
import { FooterIH, HeaderIH } from '@App/libs/interfaces'
import { Body } from '@App/libs/components/header/Header.styled'
import HeaderComponent from '@App/libs/components/header'
import { FooterComponent } from '@App/libs/components'
import { vercelLog } from '@App/libs/utils/geral'
import { API_HEADER_FOOTER } from '@App/api/api'
import { colors, fonts, spaces } from '@App/static/styles/global'

const Page404: NextPage<{ header: HeaderIH; footer: FooterIH }> = ({
    header,
    footer
}) => {
    return (
        <div className='page'>
            <Head>
                <title>Página não encontrada - JOTA</title>
                <meta
                    name='description'
                    content={GLOBAL_CONSTANT.SITE_DESCRIPTION}
                />
                <meta name='robots' content='noindex' />
                <link rel='icon' href='/favicon.ico' />
            </Head>
            <Body>
                {header && (
                    <HeaderComponent
                        wpMenu={header.menu}
                        ctaPRO={header.pro}
                        showAcessibility={header.enableAccessibility}
                        signupLink={header.assinePage}
                    />
                )}
                <Error404 />
                {footer && <FooterComponent footer={footer} />}
            </Body>
        </div>
    )
}

export default Page404

/**
 * getStaticProps
 * @return {Promise<GetStaticPropsResult<HomePagePropsInterface>>}
 */
export const getStaticProps = async (): Promise<
    GetStaticPropsResult<unknown>
> => {
    if (!API_HEADER_FOOTER) {
        throw new Error('API_HEADER_FOOTER is not defined')
    }

    const resHeaderFooter = await fetch(API_HEADER_FOOTER)

    if (!resHeaderFooter.ok) {
        vercelLog('Failed to fetch header/footer data')
        return {
            props: {
                header: null,
                footer: null
            }
        }
    }

    const { header, footer } = await resHeaderFooter.json()

    return {
        props: {
            header,
            footer
        }
    }
}

export const EditoriaTitle = styled.h1<{ isEmpty?: boolean }>`
    ${fonts.jotaHeading04};
    color: ${colors.black.jotaBlack};
    margin: ${spaces.jotaSpacing12} 0 0 0;
    padding-bottom: ${(props) => props.isEmpty && spaces.jotaSpacing8};

    border-bottom: ${(props) =>
        props.isEmpty && `1px solid ${colors.transparent.jotaTGrayLight40}`};

    @media only screen and (max-width: ${BREAKPOINTS.MD_PX}) {
        margin-top: ${spaces.jotaSpacing12};
    }
`

export const EditoriaHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 1400px;
    padding-inline: 44px;
    padding-top: 0px;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.transparent.jotaTGrayLight40};
    z-index: -2;
    margin-top: ${spaces.jotaSpacing44};

    @media only screen and (max-width: ${BREAKPOINTS.MD_PX}) {
        flex-direction: column;
        align-items: flex-start;
        padding-inline: 36px;
    }

    @media only screen and (max-width: ${BREAKPOINTS.SM_PX}) {
        padding-inline: 16px;
        padding-top: ${spaces.jotaSpacing24};
        margin-top: inherit;
    }
`
